import React from 'react';
import {
  makeStyles, shorthands, tokens, Button, ButtonProps, mergeClasses,
} from '@fluentui/react-components';
import { ColorfulText } from './ColorfulText';

const useColorfulButtonStyles = makeStyles({
  button: {
    boxSizing: 'border-box',
    position: 'relative',
    '@media (forced-colors: none)': {
      backgroundColor: 'transparent',
      backgroundClip: 'padding-box, border-box',
      backgroundOrigin: 'border-box',
      backgroundImage: 'linear-gradient(#fff, #fff), linear-gradient(90deg, #3D07D5 6.25%, #213AD5 50%, #0078D4 92.71%)',
      ...shorthands.border('1px', 'solid', 'transparent'),
      ...shorthands.borderRadius(tokens.borderRadiusMedium),
    },
    '@media (forced-colors: active)': {
      ':hover': {
        color: 'Highlight',
        ...shorthands.borderColor('Highlight'),
      },
      ':hover:active': {
        color: 'Highlight',
      },
    },
  },
});

interface IColorfulButtonProps {
  className?: string;
  children: React.ReactNode;
}

export const ColorfulButton: React.FC<ButtonProps & IColorfulButtonProps> = React.memo((props) => {
  const styles = useColorfulButtonStyles();

  return (
    <Button {...props} className={mergeClasses(styles.button, props.className, 'inline-copilot-colorful-button')} appearance="transparent">
      <ColorfulText>
        {props.children}
      </ColorfulText>
    </Button>
  );
});
